import type { AuthUser } from '../auth/AuthContext'
import { resolveBackendFileUrl } from '../config/api'

export type BusinessPdfProfile = {
  logoAbsoluteUrl: string | null
  businessName: string | null
  vatNumber: string | null
  businessEmail: string | null
  address: string | null
  postalCode: string | null
  city: string | null
  phone: string | null
  mobile: string | null
  gemiNumber: string | null
  taxOffice: string | null
  businessActivity: string | null
  business_info: string | null
}

export function authUserToPdfProfile(
  user: AuthUser | null | undefined,
): BusinessPdfProfile {
  if (!user) {
    return {
      logoAbsoluteUrl: null,
      businessName: null,
      vatNumber: null,
      businessEmail: null,
      address: null,
      postalCode: null,
      city: null,
      phone: null,
      mobile: null,
      gemiNumber: null,
      taxOffice: null,
      businessActivity: null,
      business_info: null,
    }
  }
  return {
    logoAbsoluteUrl: resolveBackendFileUrl(user.logoUrl),
    businessName: user.businessName,
    vatNumber: user.vatNumber,
    businessEmail: user.businessEmail,
    address: user.address,
    postalCode: user.postalCode,
    city: user.city,
    phone: user.phone,
    mobile: user.mobile,
    gemiNumber: user.gemiNumber,
    taxOffice: user.taxOffice,
    businessActivity: user.businessActivity,
    business_info: user.business_info,
  }
}

export function formatBusinessAddressLines(profile: BusinessPdfProfile): string[] {
  const lines: string[] = []
  const street = profile.address?.trim()
  if (street) lines.push(street)
  const cityLine = [profile.postalCode?.trim(), profile.city?.trim()]
    .filter(Boolean)
    .join(' ')
  if (cityLine) lines.push(cityLine)
  return lines
}
